// extracted by mini-css-extract-plugin
export default {"chip":"select-chip_chip__ddkDZ"};